import { render, staticRenderFns } from "./FreightTableNewValidityPanel.vue?vue&type=template&id=673f3d35&scoped=true"
import script from "./FreightTableNewValidityPanel.vue?vue&type=script&lang=js"
export * from "./FreightTableNewValidityPanel.vue?vue&type=script&lang=js"
import style0 from "./FreightTableNewValidityPanel.vue?vue&type=style&index=0&id=673f3d35&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f3d35",
  null
  
)

export default component.exports